import { get } from '..';

const getMyUserGroups = (ClientIdEmail: string) => get(`users/v2/user-groups/${ClientIdEmail}`);

export default getMyUserGroups;
